import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="m16.242 6.667-2.709-2.709-9.374 9.375 2.708 2.709 9.375-9.375ZM5.526 11.966l.716.742M8.86 8.633l.715.742M12.192 5.3l.716.742M7.192 10.3l.717.742m2.617-4.076.716.742" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);